import { GridItem } from '@bnnvara/grids';
import React from 'react';
import PropTypes from 'prop-types';
import { ThemePublicationHeader } from '../components/headers/ThemePublicationHeader';

const ComposableThemeHeader = ({ subThemes }) => {
  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      <ThemePublicationHeader subThemes={subThemes} />
    </GridItem>
  );
};

export default ComposableThemeHeader;

ComposableThemeHeader.propTypes = {
  subThemes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      slug: PropTypes.string,
      color: PropTypes.string,
      backgroundImageUrl: PropTypes.string,
      backgroundImageMobileUrl: PropTypes.string,
      parentSlug: PropTypes.string,
      parent: {
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        color: PropTypes.string,
        slug: PropTypes.string,
        backgroundImageUrl: PropTypes.string,
        backgroundImageMobileUrl: PropTypes.string,
      },
    })
  ),
};
